// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPut, BASE_URL, retrieveToken } from "../../store/api";
import { PartnerUpdateResponse } from "./types";

import * as partnerActions from "./partner.actions";
import { showModal } from "../modal/modal.actions";

export function* updatePartner(
  action: ReturnType<typeof partnerActions.updatePartnerAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `partner/${action.payload.CO_ID}`;
    const result: Response = yield call(apiPut, url, token, action.payload);

    if (result.status === 200) {
      const parsed: PartnerUpdateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'))
      yield put(partnerActions.updatePartnerAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(partnerActions.updatePartnerAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(partnerActions.updatePartnerAsync.failure(parsed));
  }
}

export default function* partnerSagaUpdatePartner() {
  yield takeEvery(partnerActions.updatePartnerAsync.request, updatePartner);
}
